import { Skeleton } from '@/components/ui';

/**
 * Mirrors the structure of {@link DepositForm} so the layout doesn't
 * shift when the store config resolves.
 */
export function DepositFormSkeleton() {
  return (
    <div className="flex flex-col gap-5" aria-busy="true" aria-live="polite">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-3 w-24 rounded" />
        <div className="grid grid-cols-3 gap-2">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-14 rounded-card" />
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-1.5">
        <Skeleton className="h-3 w-28 rounded" />
        <Skeleton className="h-14 w-full rounded-card" />
        <Skeleton className="h-3 w-44 rounded mt-1" />
      </div>

      <Skeleton className="h-[52px] w-full rounded-tab" />
    </div>
  );
}
